import { getUserNonce, initializePersistence } from "@umami/state";
import { type PropsWithChildren, useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { clearPersistor, persistor, setupPersistor } from "../utils/persistor";
import { store } from "../utils/store";

export const ReduxStore = ({ children }: PropsWithChildren) => (
  <Provider store={store}>
    <ReduxStoreContent>{children}</ReduxStoreContent>
  </Provider>
);

const ReduxStoreContent = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const initNonce = () => {
      try {
        const nonce = getUserNonce();

        if (nonce === "") {
          clearPersistor();
        } else {
          const { persistor: newPersistor } = initializePersistence(store, nonce);
          setupPersistor(newPersistor);
        }
      } catch {
        clearPersistor();
      }
    };

    void initNonce();
  }, []);

  if (!persistor) {
    return <>{children}</>;
  }

  return (
    <PersistGate loading={children} persistor={persistor}>
      {children}
    </PersistGate>
  );
};
